
import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// ----------------------------------------------------------------------

export const HomePage = lazy(() => import('../../pages/home'));
const Page404 = lazy(() => import('../../pages/404'));
// FINANCIAL
const FinancialPage = lazy(() => import('../../pages/financial'));

// ----------------------------------------------------------------------

export const mainRoutes = [
  {
    element: (
        <Suspense>
          <Outlet />
        </Suspense>
    ),
    children: [

      { path: '404', element: <Page404 /> },
    ],
  }
];
